// removed by extract-text-webpack-plugin
module.exports = {"header":"header-1CSHP","link":"link-2RfqT","personalStatement":"personalStatement-2feOA","aboutMe":"aboutMe-39lJc","large":"large-Lo9aQ","row":"row-10nO8","location":"location-1qysG","displayName":"displayName-38F_j","profileImg":"profileImg-3zWqd","mvpImg":"mvpImg-1WLwm","userStats":"userStats-2kISX","statsChanger":"statsChanger-2XB6_","userPoints":"userPoints-PsZ3K","item":"item-e_BHw","totalSummary":"totalSummary-2cqlC","userContainer":"userContainer-O8XqD","proHighlight":"proHighlight-14_CR","userImageContainer":"userImageContainer-2AORV","linksContainer":"linksContainer-1ObIH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/summary/_userSummary.css
// module id = 331
// module chunks = 1